import { Component, Input } from '@angular/core';
import { ForgeCardModule, ForgeDividerModule, ForgeExpansionPanelModule, ForgeLabelValueModule } from '@tylertech/forge-angular';
import { Arrest, Charge } from "@tylertech/cj-inmate-search-angular-sdk";
import { SharedModule } from "../../../../modules/shared/shared.module";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'charge-details',
  standalone: true,
  templateUrl: './charge-details.component.html',
  styleUrls: ['./charge-details.component.scss'],
  imports: [
    ForgeCardModule,
    ForgeExpansionPanelModule,
    ForgeDividerModule,
    ForgeLabelValueModule,
    SharedModule,
    DatePipe
  ]
})
export class ChargeDetailsComponent {
  @Input() charge!: Charge;
  @Input() arrest!: Arrest;

  constructor() { }

}